<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-8 offset-md-2" >            
            <div class="row no-gutters" >
                <h2 class="h2" v-if="pageType == 'add' " > Create conversion </h2>
                <h2 class="h2" v-else-if="pageType == 'edit' " > Edit conversion </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form  @submit.prevent="submit" class="atlass-form col-12" >
                    <div class="row">

                        <div class="col-12 form-group" >
                            <label for="NameInput" > NAME: </label>
                            <b-form-input id="NameInput" @keyup="nameToTag"
                            type="text"
                            v-model="data.name"
                            required

                            placeholder="Name">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                             <label for="TagInput" > TAG: </label>
                            <b-form-input id="TagInput" 
                            type="text"
                            v-model="data.tag"
                            required
                            disabled
                            placeholder="$name">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                             <label for="PriceInput" > PRICE: </label>
                            <b-form-input id="PriceInput" 
                            type="text"
                            v-model="data.price"
                            required
                            placeholder="Price">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <b-button type="submit" variant="primary" class="btn-sm-w" >Save</b-button>
                            <b-button  class="btn btn-danger btn-sm-w" @click="PreventDelete()" v-if="pageType == 'edit'" > Delete </b-button >
                        </div>

                    </div>
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'productComponent',
    props: {
        ID: { 
            type: [String],
        }
        
    },
    data: function(){
        return {
            data: {
                name: '',
                tag: '',
                price: ''
            },
            errors: [],
            loaded: false,
            rows: [],
            pageType: 'add',
            requestStatus: 0,
            timeout: 100
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        //this.$store.dispatch(PROFILE_REQUEST);
        
    },
    mounted(){
        if( this.ID ){
            this.pageType = 'edit'
            this.getdata();
        }else{
            this.loaded = true
        }
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        getdata: function(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/products').doc(this.ID)

            return ref.get()
            .then((snapshot) => {
                //console.log(snapshot.data())
                this.data = snapshot.data()
                
                this.loaded = true
            })
            
        },
        nameToTag: function(){
            let name = this.data.name;
            if( this.pageType == 'add' ){
                name = name.toLowerCase()
                let tag = name.replace(/\s/g, "-");
                this.data.tag = "$"+tag;
            }
                
        },
        submit: function(){
            
            this.loaded = false
            
            let resp = this.save()
            resp.then(function(){
                
                    this.$toast.success({
                        title:'Success',
                        message: 'Conversion saved'
                    })

                    setTimeout(function(){ 
                        this.loaded = true
                        this.$parent.$parent.get_data();
                        this.$parent.fModalClose();
                    }.bind(this), this.timeout );
                
                    
                
                }.bind(this))
                .catch(function(error){
                
                    //console.error("Error updating document: ", error);
                    this.$toast.error({
                        title:'Error',
                        message: "Something went wrong: "+error
                    })
                
                    this.loaded = true
                
                }.bind(this))
            
            
            
        },
        save: function () {
            //const { firstname, lastname, website, organization, address, city, country } = this.getprofile
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            
            let document = {
                    "APPKEY": orgID,
                    "name" : this.data.name,
                    "tag" : this.data.tag,
                    "price" : Number( this.data.price ),
                    "revenue" : 0,
                }
            
            if( this.pageType == 'add' ){

                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/products')
                
                return ref.add( document )
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/products').doc( this.ID )
                
                return ref.set( document, { merge: true } )
                
            }
            
        },
        
        PreventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.deleteProduct();
                    
                }
            })
            
        },        
        deleteProduct: function(){
            
            this.$parent.$parent.PreventDelete( this.ID );
            
        }

    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/product.vue